module.exports = __webpack_public_path__ + "static/img/Frame13.d644caed.png";